// extracted by mini-css-extract-plugin
export var growableInput = "_7j-0";
export var tagContainer = "_7j-2";
export var textInput = "_7j-1";